export default class Idioma {
  constructor(texto) {
    this.texto = texto
  }
  get Texto() {
    return this.texto.idioma
  }
  get Pasos(){
    return this.texto.pasos
  }

  get Resumen(){
    return this.texto.resumen
  }

  get DatosReserva(){
    return this.texto.datosReserva
  }

  get DatosServicios(){
    return this.texto.datosServicios
  }

  get DatosResumen(){
    return this.texto.datosResumen
  }

  get DatosPersonales(){
    return this.texto.datosPersonales
  }
};



// WEBPACK FOOTER //
// ./src/_locale/Idioma.js